import {ReactComponent as Logo2} from '../../assets/svg/logo-2.svg';

export default function LogoSvg2(props: any) {
	return (
		<Logo2 {...props}/>
	)
}